import { CoreJsonResponse } from "coral-utility";
import { Model } from "types";

export interface GenericMap<T> {
  [x: string]: T;
}
export interface ModelState {
  readonly currentModels: Model[];
  uuid: GenericMap<Model>;
  editModelLoading: boolean;
  paginated: GenericMap<Model[]>;
  meta: CoreJsonMeta | null;
  buckets: GenericMap<Bucket[]>;
}

export interface Bucket {
  key: string;
  doc_count: number;
}

export interface QueryFilter {
  values: string[];
  operator: "or"
  lt?: string;
  gt?: string;
  type?: "range";
}

export interface SearchDefinition {
  maxPerPage: number;
  currentPage: number;
  searchText?: string;
  filters?: GenericMap<QueryFilter>
}

export const defaultModelParams: SearchDefinition = {
  currentPage: 1,
  maxPerPage: 15,
};

export const GET_CURRENT_MODELS = "GET_CURRENT_MODELS";
export const SET_CURRENT_MODELS = "SET_CURRENT_MODELS";

export const CREATE_NEW_MODEL = "CREATE_NEW_MODEL";

export const GET_EDIT_MODEL_LOADING = "GET_EDIT_MODEL_LOADING";
export const SET_EDIT_MODEL_LOADING = "SET_EDIT_MODEL_LOADING";

export const GET_PAGINATED_MODELS = "GET_PAGINATED_MODELS";
export const GET_PAGINATED_MODELS_SUCCESS = "GET_PAGINATED_MODELS_SUCCESS";

export const GET_BUCKETS = "GET_BUCKETS";
export const GET_BUCKETS_SUCCESS = "GET_BUCKETS_SUCCESS";

export const GET_MODEL_DETAILS = "GET_MODEL_DETAILS";
export const GET_MODEL_DETAILS_SUCCESS = "GET_MODEL_DETAILS_SUCCESS";

export interface CoreJsonMeta {
  totalPages: number;
  totalResults: number;
  numberResults: number;
  currentPageNumber: number;
  currentPageOffsetStart: number;
  currentPageOffsetEnd: number;
}

interface FetchPaginatedModelsSuccessAction {
  type: typeof GET_PAGINATED_MODELS_SUCCESS;
  payload: CoreJsonResponse<Model[], CoreJsonMeta>;
}

interface FetchBucketsSuccessAction {
  type: typeof GET_BUCKETS_SUCCESS;
  payload: CoreJsonResponse<GenericMap<Bucket[]>, null>;
}
export interface FetchPaginatedModelsAction {
  type: typeof GET_PAGINATED_MODELS;
  payload: SearchDefinition;
}
export interface SetModelsAction {
  type: typeof SET_CURRENT_MODELS;
  payload: Model[];
}

export interface SetEditModelLoadingAction {
  type: typeof SET_EDIT_MODEL_LOADING;
  payload: boolean;
}

export interface NewModelAction {
  type: typeof CREATE_NEW_MODEL;
  payload: FormData;
}

export type ModelActionTypes =
  | SetModelsAction
  | FetchBucketsSuccessAction
  | FetchPaginatedModelsSuccessAction
  | SetEditModelLoadingAction;
